import { Injectable, inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { ErrorReportingService } from '../services/error-reporting.service';
import { RightBridgeApiService } from '../services/right-bridge-api.service';
import { EnvironmentService } from '../services/environment.service';
import { SessionStorageService } from '../services/session-storage.service';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Policy, PolicyDetail } from '../models/annuity-models';

@Injectable({
  providedIn: 'root',
})
export class DtccService {
  private envSvc = inject(EnvironmentService);
  private errSvc = inject(ErrorReportingService);
  private rbs = inject(RightBridgeApiService);
  private ss = inject(SessionStorageService);

  environment;
  baseUrl;
  app;
  org;

  constructor() {
    this.environment = this.envSvc.get();
    this.baseUrl = this.environment.apiBase;
    this.app = this.ss.get('currentApp') || this.environment.defaultApp || 'rb';
    this.org = this.environment.org || 'basev2';
  }

  searchPolicies(producer, policy?, name?): Observable<Policy> {
    const id = this.ss.get('session');
    const reqHeaders = new HttpHeaders()
      .set('X-RB-S', id)
      .set('X-RB-I', 'aw')
      .set('X-RB-O', this.org);

    let url = `${this.baseUrl}/Dtcc/SearchPolicy?producerNumber=${producer}`;

    if (policy) {
      url += `&PolicyNumber=${policy}`;
    }

    if (name) {
      url += `&ClientLastName=${name.toUpperCase()}`;
    }

    return this.rbs.getRequest<Policy>(url, reqHeaders);
  }

  getPolicyDetails(policy, participantNumber): Observable<PolicyDetail> {
    const id = this.ss.get('session');
    const reqHeaders = new HttpHeaders()
      .set('X-RB-S', id)
      .set('X-RB-I', 'aw')
      .set('X-RB-O', this.org);

    const url = `${this.baseUrl}/Dtcc/GetPolicy?insurancePolicyPolNumber=${policy}&insuranceParticipantCarrierParticipantNumber=${participantNumber}`;

    return this.rbs.getRequest<PolicyDetail>(url, reqHeaders).pipe(
      res => {
        return res;
      },
      catchError(error => {
        return this.errSvc.handleError(error);
      })
    );
  }

  getPolicyDetailsComplete(policy, participantNumber, firmID) {
    const id = this.ss.get('session');
    const reqHeaders = new HttpHeaders()
      .set('X-RB-S', id)
      .set('X-RB-I', 'aw')
      .set('X-RB-O', this.org);
    const url = `${this.baseUrl}/Dtcc/GetPolicyComplete?insurancePolicyPolNumber=${policy}&insuranceParticipantCarrierParticipantNumber=${participantNumber}&mappingID=DTCCExchange&insuranceParticipantAssociatedFirmID=${firmID}`;

    return this.rbs.getRequest<any>(url, reqHeaders).pipe(
      res => {
        return res;
      },
      catchError(error => {
        return this.errSvc.handleError(error);
      })
    );
  }
  getNPNs(userID: string, profileID?: string) {
    const sess = this.ss.get('session');
    const reqHeaders = new HttpHeaders()
      .set('X-RB-S', sess)
      .set('X-RB-I', 'aw')
      .set('X-RB-O', this.org);
    let url = `${this.baseUrl}/User/${userID}/npn`;
    if (profileID) {
      url += `?profileID=${profileID}`;
    }
    return this.rbs.getRequest<any>(url, reqHeaders).pipe(
      res => {
        return res;
      },
      catchError(error => {
        return this.errSvc.handleError(error);
      })
    );
  }
}
